module.exports = __webpack_public_path__ + "static/media/dinosaur(3).c4a65d91.PNG";